import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AdminGenericService } from './modules/landingpage/service/admin-generic.service';
import { HomeService } from './modules/landingpage/service/home.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  typeUser = 0;
  title = 'mmcb-geobosques-appweb';

  private routerSubscription!: Subscription;

  constructor(
    private router: Router,
    private adminGenericService: AdminGenericService,
    private homeService: HomeService
  ) { }

  ngOnInit() {
    this.routerSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        const currentUrl = this.router.url;
        let _typeUser = currentUrl.includes('/gestor') || currentUrl.includes('/reporte') ? 1 : 0;
        this.adminGenericService.setTypeUser(_typeUser);
      }
    });
    this.adminGenericService.typeUser$.subscribe(type => {
      this.typeUser = type;
    });
    const body = {
      registerType: 1,
      downloadId: 0
    };

    this.homeService.postEvent(body).subscribe({
      next: (response) => {
        if (response.status === 200) {

        }
      },
      error: (erro) => {
        console.log(erro)
      }
    });
  }
}
